import 'whatwg-fetch'

export function fetch(user, url, init) {
    return user.getIdToken().then(token => {
            if (!init)
                init = {};
            if (!init.headers)
                init.headers = {};

            init.headers.Authorization = "Bearer " + token;

            return window.fetch(url, init)
        }
    );
}

export function fetchPublic(url, init) {
    return window.fetch(url, init)
}
